import React, { FC } from 'react';
import styles from './icons.module.scss';

const IconDown: FC = () => (
  <img src="/images/icon_chevron_open.svg" alt="open filter section" className={styles.icon} />
);

export default IconDown;
